module.exports = __webpack_public_path__ + "img/status_5.2f84cb92.png";